import type { InvokeErr } from '../../shared/supabase/invokeErrorUtils';

/** Mensaje legible desde invoke Edge (body.error o context JSON). */
export async function parseSupabaseInvokeError(
  error: InvokeErr | { message?: string; context?: Response } | null | undefined,
  fallback: string,
  bodyError?: string | null
): Promise<string> {
  let message = bodyError ?? error?.message ?? fallback;
  try {
    const ctx = error?.context;
    if (ctx && typeof (ctx as Response).json === 'function') {
      const parsed = (await (ctx as Response).json()) as { error?: string };
      if (parsed?.error) message = parsed.error;
    } else if (ctx && 'body' in ctx && typeof (ctx as { body?: string }).body === 'string') {
      const parsed = JSON.parse((ctx as { body: string }).body) as { error?: string };
      if (parsed?.error) message = parsed.error;
    }
  } catch {
    // Mantener mensaje ya resuelto.
  }
  return message;
}
